import {CtModelRouteData} from "@ctsolution/ct-framework";

export const NotesRouteData = (): CtModelRouteData => CtModelRouteData
  .create()
  .setController("Notes");
